module.exports = __webpack_public_path__ + "img/car_00010.e907ea9b.jpg";